// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
  
  apiUrl: 'https://walaxdevnewapi.expertapps.com.sa/api', // NEW DEV
  //  apiUrl: 'https://expoapi.amjad.ai/api', 

  // appUrl: 'https://walaxdev.expertapps.com.sa', // DEV
  // apiUrl: 'https://walaxdevapi.expertapps.com.sa/api', // DEV
  // signalR: 'https://diwandevslr.expertapps.com.sa/hubs', // DEV

  // appUrl: 'https://walaxtest.expertapps.com.sa', // Test
  // // apiUrl: 'https://walaxtestapi.expertapps.com.sa/api', // Test
  // signalR: 'https://diwandevslr.expertapps.com.sa/hubs', // Test

  // apiUrl: 'https://walaxstageapi.expertapps.com.sa/api', // Stage

  // apiUrl: 'https://api.offer-x.co/api', // Prod

  // apiUrl: 'https://walaxstagenewapi.expertapps.com.sa/api', // NEW STAGE
  // apiUrl: 'https://api.amjad.ai/api', 
  employee_link: "https://walaxempdev.expertapps.com.sa/login",
  url: 'https://walaxstagenewapi.expertapps.com.sa',
  mapsApiKey: "AIzaSyDAJBhTNZ8KII7etJztNX1tpfsBXUEqfrw",
  googleSiteKey: '6Lfm3xohAAAAALgLSfUIY8YHdzC16AjLY6wl7U9a',
  googleApiKey: '6Lfm3xohAAAAADEauzDDPzU0YVrIxWTBbi1k3AkE',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
